import { Material, Mesh, MeshStandardMaterial, Object3D } from 'three'
import { useSceneStore } from '../../../a.scenes/GameScene/store'
import { CHARACTER_VARIANTS } from '../../Characters/scripts/constants'
import AsphaltMaterialProps from '../../materials/AsphaltMaterialProps'

export const restoreFromAsphaltMaterials = (obj: Object3D) => {
  const materialsCache = useSceneStore.getState().getMaterials()
  obj.traverse((o: Object3D | Mesh) => {
    if (o.type === 'Mesh') {
      const mesh = o as Mesh
      const mat = mesh.material as MeshStandardMaterial
      const matPosfix = `_${CHARACTER_VARIANTS.STATUE}`

      if (mat.name.includes(matPosfix)) {
        const originalName = mat.name.replace(matPosfix, '')
        mesh.material = materialsCache.get(originalName) as Material
      }
    }
  })
}

const replaceAsphaltMaterial = (obj: Object3D) => {
  const materialsCache = useSceneStore.getState().getMaterials()
  const addMaterial = useSceneStore.getState().addMaterial
  obj.traverse((o: Object3D | Mesh) => {
    if (o.type === 'Mesh') {
      const mesh = o as Mesh
      const mat = mesh.material as MeshStandardMaterial
      // save current material in cache
      if (!materialsCache.has(mat.name)) {
        addMaterial(mat.name, mat)
      }
      const newMatKey = `${mat.name}_${CHARACTER_VARIANTS.STATUE}`
      if (!materialsCache.has(newMatKey)) {
        const newMat = new MeshStandardMaterial({ ...AsphaltMaterialProps, name: newMatKey })
        addMaterial(newMatKey, newMat)
      }
      mesh.material = materialsCache.get(newMatKey) as Material
    }
  })
}
export default replaceAsphaltMaterial
